// Initialize Owl Carousel
$(document).ready(function () {
    $('.announcement-bar-contents').owlCarousel({
      loop: true,
      autoplay: true,
      autoplayTimeout: 5000,
      items: 1,
      dots: false,
    });
  });
  